/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *  ╔═○─┐ emotive
 *    ●●  ENGINE - Step Down Gesture
 *  └─○═╝
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *
 * Quick weight shift downward (1 beat)
 */

import { createStepGesture } from './danceSteps.js';

export default createStepGesture('down');
